import { S } from "../styles";

export function DriveStatusBar({ drive, onSignIn, onSave, onSignOut, lastSaved }) {
  const { user, status, error, isSignedIn } = drive;

  if (!isSignedIn) {
    return (
      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
        <button
          onClick={onSignIn}
          disabled={status === "signing-in"}
          style={{
            background:"#fff", color:"#384460", border:"1px solid #ddd", borderRadius:7,
            padding:"7px 16px", cursor:"pointer", fontSize:12, fontWeight:600,
            display:"flex", alignItems:"center", gap:8, opacity: status === "signing-in" ? 0.6 : 1,
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          {status === "signing-in" ? "Signing in..." : "Sign in with Google"}
        </button>
        {error && <span style={{ color:"#e08070", fontSize:11 }}>{error}</span>}
      </div>
    );
  }

  const statusText = {
    loading: "Loading from Drive...",
    saving: "Saving to Drive...",
    ready: lastSaved ? `Saved ${lastSaved}` : "Connected",
    error: error || "Error",
  }[status] || "Connected";

  const statusColor = status === "error" ? "#e08070" : status === "saving" || status === "loading" ? "#c29a52" : "#31b4a6";

  return (
    <div style={{ display:"flex", alignItems:"center", gap:12 }}>
      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
        {user?.picture && <img src={user.picture} alt="" style={{ width:24, height:24, borderRadius:"50%" }} referrerPolicy="no-referrer" />}
        <div>
          <div style={{ fontSize:11, color:"#ffffff", fontWeight:600 }}>{user?.name || user?.email}</div>
          <div style={{ fontSize:10, color:statusColor }}>{statusText}</div>
        </div>
      </div>
      <button onClick={onSave} disabled={status === "saving"} style={{ ...S.btnGhost, padding:"5px 12px", fontSize:11 }}>
        Save Now
      </button>
      <button onClick={onSignOut} style={{ ...S.btnGhost, padding:"5px 12px", fontSize:11, color:"#75788b" }}>
        Sign Out
      </button>
    </div>
  );
}
